/**
 * First-touch marketing attribution for new accounts (added 2026-09-27).
 *
 * main.ts stores utm_* / dsref / oppref from decorated digitalsignage.com links in
 * sessionStorage.ds_attrib. This helper posts them with the businessId to mars
 * (/dwAccountAttribution), which keeps the row only for accounts created in the last
 * 30 days and inserts once per business. It is therefore safe to call on EVERY login
 * and after account creation; the first call that carries a valid businessId wins.
 *
 * Transport: fetch with a form-encoded body (no CORS preflight) and keepalive (the
 * request survives a navigation right after signup). Never throws, never blocks.
 */
export function reportAccountAttributionOnce(globalService: string, businessId: any): void {
    try {
        const bid = String(businessId == null ? '' : businessId).trim();
        if (!globalService || !/^\d{1,12}$/.test(bid)) return;
        const raw = sessionStorage.getItem('ds_attrib');
        if (!raw) return;
        if (sessionStorage.getItem('ds_attrib_sent') === bid) return;
        const data = Object.assign({businessId: bid}, JSON.parse(raw));
        const body = new URLSearchParams();
        Object.keys(data).forEach((k) => body.append(k, data[k] == null ? '' : String(data[k])));
        const done = () => { try { sessionStorage.setItem('ds_attrib_sent', bid); } catch (e) { /* ignore */ } };
        if (typeof fetch === 'function') {
            fetch(`${globalService}/dwAccountAttribution`, {method: 'POST', body, keepalive: true, mode: 'cors', credentials: 'omit'})
                .then(done)
                .catch(() => { /* best effort */ });
        } else if (typeof XMLHttpRequest === 'function') {
            const xhr = new XMLHttpRequest();
            xhr.open('POST', `${globalService}/dwAccountAttribution`, true);
            xhr.onload = done;
            xhr.send(body);
        }
    } catch (e) {
        // attribution must never affect login or signup
    }
}
